import styles from "./CategoryTile.module.scss";

interface CategoryTileProps {
  name: string;
  /** The category's own photo, when it has one. */
  imageUrl?: string;
  subtitle?: string;
  onClick: () => void;
}

/** A large, photo-backed category card. */
function CategoryTile(props: CategoryTileProps) {
  const { name, imageUrl, subtitle, onClick } = props;

  return (
    <div
      className={`${styles.categoryTile} ${
        imageUrl ? styles.categoryTilePhoto : ""
      }`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick();
        }
      }}
    >
      {imageUrl ? (
        <>
          <img src={imageUrl} alt="" className={styles.categoryTileImage} />
          <div className={styles.categoryTileScrim} />
        </>
      ) : null}
      <div className={styles.categoryTileTextGroup}>
        <p className={`body-bold-medium ${styles.categoryTileName}`}>{name}</p>
        {subtitle ? (
          <p className={`body-small ${styles.categoryTileCount}`}>{subtitle}</p>
        ) : null}
      </div>
    </div>
  );
}

export default CategoryTile;
